(function () {
  const BLOCKED_DOMAIN_LABELS = ['teste'];
  const BLOCKED_DOMAIN_ERROR_MESSAGE = 'Domínio "@teste" inválido.';

  function normalizeEmail(value) {
    return typeof value === 'string' ? value.trim().toLowerCase() : '';
  }

  function getDomainLabels(email) {
    const normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail || !normalizedEmail.includes('@')) return [];

    const emailParts = normalizedEmail.split('@');
    if (emailParts.length !== 2) return [];

    const domain = emailParts[1];
    if (!domain) return [];

    return domain
      .split('.')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function getBlockedDomainMessage(email) {
    const labels = getDomainLabels(email);
    if (!labels.length) return '';

    const hasBlockedLabel = labels.some(function (label) {
      return BLOCKED_DOMAIN_LABELS.includes(label);
    });

    return hasBlockedLabel ? BLOCKED_DOMAIN_ERROR_MESSAGE : '';
  }

  function getFieldEmailValue(input) {
    if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLTextAreaElement)) {
      return '';
    }

    return typeof input.value === 'string' ? input.value : '';
  }

  function fieldLooksLikeEmail(input) {
    if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLTextAreaElement)) {
      return false;
    }

    if (input instanceof HTMLInputElement && input.type === 'hidden') {
      return false;
    }

    if (input instanceof HTMLInputElement && input.type === 'email') {
      return true;
    }

    const signals = [
      input.getAttribute('type'),
      input.getAttribute('name'),
      input.getAttribute('id'),
      input.getAttribute('autocomplete'),
      input.getAttribute('placeholder'),
      input.getAttribute('aria-label'),
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return /\bemail\b|e-mail/.test(signals);
  }

  function validateEmailInput(input) {
    if (!fieldLooksLikeEmail(input)) {
      return true;
    }

    const message = getBlockedDomainMessage(getFieldEmailValue(input));
    input.setCustomValidity(message);
    return !message;
  }

  function isEmailAllowed(email) {
    return !getBlockedDomainMessage(email);
  }

  function handleEmailEvent(event) {
    const target = event.target;
    if (!fieldLooksLikeEmail(target)) {
      return;
    }

    validateEmailInput(target);
  }

  window.CelsoEmailValidation = {
    blockedDomainLabels: BLOCKED_DOMAIN_LABELS.slice(),
    getBlockedDomainMessage: getBlockedDomainMessage,
    isEmailAllowed: isEmailAllowed,
    validateEmailInput: validateEmailInput,
    fieldLooksLikeEmail: fieldLooksLikeEmail,
  };

  document.addEventListener('input', handleEmailEvent, true);
  document.addEventListener('change', handleEmailEvent, true);
  document.addEventListener('blur', handleEmailEvent, true);
  document.addEventListener(
    'invalid',
    function (event) {
      handleEmailEvent(event);
    },
    true
  );
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const emailFields = Array.from(form.querySelectorAll('input, textarea')).filter(fieldLooksLikeEmail);
      const invalidField = emailFields.find(function (field) {
        return !validateEmailInput(field);
      });

      if (!invalidField) return;

      event.preventDefault();
      if (typeof invalidField.reportValidity === 'function') {
        invalidField.reportValidity();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('input, textarea').forEach(validateEmailInput);
    });
  } else {
    document.querySelectorAll('input, textarea').forEach(validateEmailInput);
  }
})();
